export default __webpack_public_path__ + "static/media/1675.c397d909.png";